import { concat, includes, pipe, reject } from "ramda";
const EFIGS = [
  {
    name: "English",
    isoCode639_1: "en",
    isoCode639_2: "eng",
    id: "eng",
    displayName: "English",
  },
  {
    name: "French",
    isoCode639_1: "fr",
    isoCode639_2: "fre",
    id: "fre",
    displayName: "French",
  },
  {
    name: "Italian",
    isoCode639_1: "it",
    isoCode639_2: "ita",
    id: "ita",
    displayName: "Italian",
  },
  {
    name: "German",
    isoCode639_1: "de",
    isoCode639_2: "ger",
    id: "ger",
    displayName: "German",
  },
  {
    name: "Spanish",
    isoCode639_1: "es",
    isoCode639_2: "spa",
    id: "spa",
    displayName: "Spanish",
  },
];

export const prependEFIGS = pipe(
  reject(l => includes(l.id, ["eng", "fre", "ita", "ger", "spa"])),
  concat(EFIGS),
);

const EFIGS_STIP = [
  {
    name: "English",
    id: "eng",
    code: "eng",
  },
  {
    name: "French",
    id: "fre",
    code: "fre",
  },
  {
    name: "Italian",
    id: "ita",
    code: "ita",
  },
  {
    name: "German",
    id: "ger",
    code: "ger",
  },
  {
    name: "Spanish",
    id: "spa",
    code: "spa",
  },
];

export const prependStipEFIGS = pipe(
  reject(l => includes(l.id, ["eng", "fre", "ita", "ger", "spa"])),
  concat(EFIGS_STIP),
);

export const EFIGS_ORDER = {
  eng: 0,
  fre: 1,
  ita: 2,
  ger: 3,
  spa: 4,
};
